import { rem } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
import { white } from '../../../../common/colors';
import { StyledInformationalPage } from '../../../../common/static.styles';
import { HeadTitle } from '../../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../../layout/default/DefaultLayout';

// @todo
const seo = {
  description: '',
};

const AboutWarnerBros = styled(StyledInformationalPage)`
  .border-bottom {
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
  }
  sup {
    vertical-align: top;
    position: relative;
    top: ${rem(-8)};
    font-size: ${rem(12)};
  }
  .page-links-wrapper {
    background: ${white};

    ul li {
      padding-bottom: 10px;
    }
  }
`;

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='en-IN' seo={seo}>
    <HeadTitle title='About' />
    <AboutWarnerBros>
      <div className='content'>
        <article>
          <h1>About Warner Bros.</h1>
          <p>
            <strong>WARNER BROS. ENTERTAINMENT</strong> is a global leader in all forms of entertainment and their
            related businesses across all current and emerging media and platforms. A Time Warner Company, the Studio
            stands at the forefront of every aspect of the entertainment industry from feature film, television and home
            entertainment production and worldwide distribution to DVD and Blu-ray, digital distribution, video games,
            animation, product and brand licensing, and broadcasting. DC Entertainment, the company behind the world’s
            most iconic Super Heroes, including Batman, Superman, Wonder Woman, The Flash and hundreds more, is also
            part of Warner Bros.
          </p>

          <p>
            Warner Bros. Studios began when four brothers, Albert, Sam, Harry and Jack L. Warner, incorporated their
            fledgling movie company on April 4, 1923. In 1927, the release of the world’s first synchronized-sound
            feature film “The Jazz Singer” set a character and tone of innovation and influence that would become
            synonymous with the name Warner Bros.
          </p>

          <p>
            Since those early days, Warner Bros. Studios has amassed an impressive legacy, while creating a diversified
            entertainment company with unparalleled depth and breadth. The company’s consistency and long-term success
            are built on a foundation of stable management throughout its history, long-standing creative relationships
            with many of the world’s leading stars and producers, and an unwavering dedication to excellence.
          </p>

          <p>
            Today, the Warner Bros. library, one of the most prestigious and valuable in the world, consists of more
            than 79,000 hours of programming, including nearly 7,500 feature films and 4,500 television programs
            comprised of tens of thousands of individual episodes. The Studio also manages one of the most successful
            collections of brands and franchises in the world.
          </p>
        </article>
      </div>
    </AboutWarnerBros>
  </DefaultLayout>
);
